import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  OpAutocompleterComponent,
} from 'core-app/shared/components/autocompleter/op-autocompleter/op-autocompleter.component';
import { InjectField } from 'core-app/shared/helpers/angular/inject-field.decorator';
import { ApiV3Service } from 'core-app/core/apiv3/api-v3.service';
import { from, Observable, of } from 'rxjs';
import { HalResource } from 'core-app/features/hal/resources/hal-resource';
import { catchError, map } from 'rxjs/operators';
import { ApiV3FilterBuilder } from 'core-app/shared/helpers/api-v3/api-v3-filter-builder';
import { HalResourceNotificationService } from 'core-app/features/hal/services/hal-resource-notification.service';
import { AttachmentAutocompleterTemplateComponent } from './attachment-autocompleter-template.component';

export interface IAttachmentAutocompleteItem extends HalResource {
  id:string,
}

@Component({
  selector: 'op-attachment-autocompleter',
  templateUrl: '../../../../../../../../frontend/src/app/shared/components/autocompleter/op-autocompleter/op-autocompleter.component.html',
  styleUrls: ['../../../../../../../../frontend/src/app/shared/components/autocompleter/op-autocompleter/op-autocompleter.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentAutocompleterComponent extends OpAutocompleterComponent<IAttachmentAutocompleteItem> {
  @InjectField() apiV3Service:ApiV3Service;

  @InjectField() hiddenOverflowContainer = 'body';

  @InjectField() notificationService:HalResourceNotificationService;

  resource:TOpAutocompleterResource = 'work_packages';

  appendTo = 'body';

  getOptionsFn = this.getAutocompleterData.bind(this);

  ngOnInit() {
    super.ngOnInit();

    this.applyTemplates(AttachmentAutocompleterTemplateComponent, {});
  }

  getAutocompleterData(query:string|null):Observable<HalResource[]> {
    // Return when the search string is empty
    if (query === null || query.length === 0) {
      return of([]);
    }

    return from(
      this.apiV3Service
        .attachments
        .filtered(this.createFilters(query))
        .get()
        .pipe(
          map((collection) => collection.elements),
          catchError((error:unknown) => {
            this.notificationService.handleRawError(error);
            return of([]);
          }),
        ),
    );
  }

  private createFilters(searchTerm?:string):ApiV3FilterBuilder {
    const finalFilters = new ApiV3FilterBuilder();

    if (this.filters) {
      this.filters.forEach((filter) => {
        finalFilters.add(filter.name, filter.operator, filter.values);
      });
    }
    if (searchTerm?.length) {
      finalFilters.add(this.searchKey || 'filename', '~', [searchTerm]);
    }

    return finalFilters;
  }
}
